// extracted by mini-css-extract-plugin
export default {"mobilePageContainer":"mobile-default-page_mobilePageContainer__NwyoO","mainContent":"mobile-default-page_mainContent__+xZsI"};